import { Stack } from '@mui/material';
import { KanbanBoard } from './KanbanBoard';
import { KanbanHeader } from './KanbanHeader';
import { StatusWidget } from './StatusWidget';

export const ZonesByStatus = () => {
  return (
    <Stack paddingTop="3.2rem">
      <StatusWidget />
      <KanbanHeader />
      <KanbanBoard />
    </Stack>
  );
};
